import React from 'react';
import { Navigate, Outlet } from "react-router-dom";

const GuardedRoute = ({ userPrivilege, requirePrvilage, authFailPath="/home" }) => {
        return userPrivilege.includes(requirePrvilage)
            ? <Outlet />
            : <Navigate to={authFailPath} />
}

export default GuardedRoute;